import React from "react";
import "./Contact.css";
import Icon from "../Icon";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import SEO from "../SEO";
import { business } from "../../seo/business";

const Contact = () => {
  return (
    <main className="center-container fade-in" id="main-content" role="main">
      <SEO
        title="Contact Us"
        description="Contact Benson Dental Studio at 2260 Benson Ave in Bensonhurst, Brooklyn. Call 718-266-5889. Open Tuesday to Friday. Serving Sheepshead Bay, Bay Ridge & South Brooklyn."
        canonical="/contact"
      />
      <section className="contact-container" aria-labelledby="contact-heading">
        <header className="contact-header">
          <h1 id="contact-heading">Contact Us</h1>
          <p>Get in touch with Benson Dental Studio in Bensonhurst, Brooklyn</p>
          <p className="contact-note">
            Call us for appointments and urgent questions. Email replies may
            take several days.
          </p>
        </header>

        <nav className="contact-pills" aria-label="Contact methods">
          <a
            href={`tel:${business.phone}`}
            className="contact-pill contact-pill--phone"
            aria-label={`Call us at ${business.phone}`}
          >
            <Icon icon={faPhone} />
            {business.phone}
          </a>
          <a
            href={`mailto:${business.email}`}
            className="contact-pill contact-pill--email"
            aria-label={`Send us an email at ${business.email}`}
          >
            <Icon icon={faEnvelope} />
            {business.email}
          </a>
        </nav>

        {/* <Divider horizontal>OR CONTACT US DIRECTLY</Divider>
        <ContactForm /> */}
      </section>
    </main>
  );
};

export default Contact;
